import React, { useState } from 'react';
import logo from '../Images/logo.png';
import { variables } from '../Variables/Variable';
import { toast } from 'react-toastify';

const Footer = () => {
    const [emailNewsLetter, setEmailNewsLetter] = useState("");
    var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    function isValid() {
        if (emailNewsLetter === "") {
            toast.error("please Provide your Email");
            return false;
        } else if (!emailregx.test(emailNewsLetter)) {
            toast.error("Bad email format");
        } else {
            return true;
        }

    }

    const HandleSubmit = (e) => {
        e.preventDefault();
        if (isValid()) {
            fetch(variables.API_URL + "NewsLetter/SubscribeToNewsLetter", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": variables.API_URL,
                },
                body: JSON.stringify({
                    Email: emailNewsLetter,
                }),
            })
                .then((response) => {
                    if (response.ok) {
                        toast.success("Subscribed Successfully");
                        setEmailNewsLetter("");
                        return response.json();
                    }
                    return response.text().then((text) => {
                        throw new Error(text);
                    });
                })
        }
    }
    return (
        <>
            {/* <!--Start Footer One--> */}
            <footer className="footer-one footer-one--two">
                <div className="footer-one__bg" style={{ backgroundImage: "url(/assets/images/backgrounds/tile.jpg)" }}>
                </div>
                <div className="footer-one__top">
                    <div className="container">

                        <div className="footer-one--two__contact-box">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="footer-one--two__contact-box-inner text-center">
                                        <h2>Schedule a meeting.<br /> or call us at <a href="tel:01558517">+ 961 1 558517/+961 8 554546</a></h2>

                                        <div className="footer-one--two__contact-box-btn">
                                            <a href="/Contact/9" className="thm-btn">Contact Us</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>


                </div>

                <div className='bg-white'>
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="footer-one__top-wrapper">
                                    <div className="row">
                                        {/* <!--Start Footer Widget Column--> */}
                                        <div className="col-xl-4 col-lg-4 col-md-6 wow animated fadeInUp" data-wow-delay="0.1s">
                                            <div className="footer-widget__column footer-widget__about">
                                                <div className="footer-widget__about-logo">
                                                    <a href="/"><img src={logo}
                                                        alt="" /></a>
                                                </div>
                                                <p className="footer-widget__about-text">Sibai Center, Al Aried St.,<br />
                                                    Haret Hreik, Lebanon</p>

                                                <div className="footer-widget__contact-info-social-links">
                                                    <ul>
                                                        <li><a href="https://www.facebook.com/homedepotlebanon" target="_blank"><i className="fab fa-facebook"></i></a></li>
                                                        <li><a href="https://www.instagram.com/homedepotoflebanon/?hl=en" target="_blank"><i className="fab fa-instagram"></i></a></li>
                                                        <li><a href="https://www.linkedin.com/company/home-depot-of-lebanon" target="_blank"><i className="fab fa-linkedin"></i></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <!--End Footer Widget Column--> */}


                                        {/* <!--Start Footer Widget Column--> */}
                                        <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.3s">
                                            <div className="footer-widget__column footer-widget__services">
                                                <h2 className="footer-widget__title">Categories</h2>
                                                <ul className="footer-widget__services-list">
                                                    <li className="footer-widget__services-list-item">
                                                        <a href="/Tiles/13">Tiles</a>
                                                    </li>
                                                    <li className="footer-widget__services-list-item">
                                                        <a href="/Mosaics/16">Mosaics</a>
                                                    </li>
                                                    <li className="footer-widget__services-list-item">
                                                        <a href="/Ceramic Slabs/17">Ceramic Slabs</a>
                                                    </li>
                                                    <li className="footer-widget__services-list-item">
                                                        <a href="/Profiles/25">Jacuzzi</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* <!--End Footer Widget Column--> */}

                                        {/* <!--Start Footer Widget Column--> */}
                                        <div className="col-xl-2 col-lg-2 col-md-6 wow animated fadeInUp" data-wow-delay="0.5s">
                                            <div className="footer-widget__column footer-widget__quick-links">
                                                <h2 className="footer-widget__title">Quick Links</h2>
                                                <ul className="footer-widget__quick-links-list">
                                                    <li className="footer-widget__quick-links-list-item"><a
                                                        href="/">Home</a></li>
                                                    <li className="footer-widget__quick-links-list-item"><a
                                                        href="/Contact/9">Contact us</a></li>
                                                    <li className="footer-widget__quick-links-list-item"><a
                                                        href="/Protfolio/7">Gallery</a></li>
                                                    <li className="footer-widget__quick-links-list-item"><a
                                                        href="/Careers/31">Careers</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* <!--End Footer Widget Column--> */}


                                        {/* <!--Start Footer Widget Column--> */}
                                        <div className="col-xl-3 col-lg-3 col-md-6 wow animated fadeInUp" data-wow-delay="0.7s">
                                            <div className="footer-widget__column footer-widget__contact-info">
                                                <h2 className="footer-widget__title">Get In Touch</h2>

                                                <div className="footer-widget__contact-info-subscribe-box">
                                                    <form className="footer-widget__contact-subscribe-form" onSubmit={HandleSubmit}>
                                                        <div className="input-box">
                                                            <input type="email" name="email" placeholder="Email address" onChange={(e) => setEmailNewsLetter(e.target.value)} />
                                                        </div>
                                                        <button type="submit"><img src="/assets/images/icon/right-arrow.png"
                                                            alt="" /></button>
                                                    </form>
                                                    <p className="footer-widget__about-email"><a
                                                        href="mailto:info@Homedepotoflebanon.com">info@Homedepotoflebanon.com</a></p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer-one__bottom clearfix">
                    <div className="container">
                        <div className="row mt-0">
                            <div className="col-xl-12">
                                <div className="footer-one__bottom-inner">
                                    <div className="footer-one__bottom-text">
                                        <p>
                                            © Copyrights @{new Date().getFullYear()} – Developed by{" "}
                                            <a
                                                href="https://hyveonline.com"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                hyveonline
                                            </a>{" "}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer